module.exports = __webpack_public_path__ + "static/media/4.25eda8b4.jpg";